module.exports = __webpack_public_path__ + "img/Later Daters.309e641b.jpg";